import React from 'react';
import { Close } from '@mui/icons-material';
import logoAiVoice from '@src/assets/logo/logo-AiVoice-new.svg';
import { COLOR } from '@src/styles/color';
import { StyledDialogLayout } from './index.style';

const DialogLayout = ({ children, onClose }) => (
  <StyledDialogLayout>
    <div className="dialog-inner">
      <div className="dialog-logo">
        <img src={logoAiVoice} alt="AIVoice" width={131} height={44} />
      </div>
      <div className="dialog-content">{children}</div>
    </div>
    <button
      type="button"
      className="dialog-close-button"
      onClick={onClose}
      aria-label="Close"
    >
      <Close style={{ fontSize: 20, color: COLOR.indigo.default }} />
    </button>
  </StyledDialogLayout>
);

export default DialogLayout;
